import axios from 'axios';

export const getCommissionsList = search =>
  axios.get(`/backoffice/partnership/systems/commissions/`, { params: { ...search } });

export const editCommission = (commissionId, amount) =>
  axios.put(`/backoffice/partnership/systems/commissions/${commissionId}/`, { amount }, { validateStatus: false });

export const payCommissions = payload => axios.post(`/backoffice/partnership/systems/commissions/pay/`, { ...payload });

export const rejectRewards = payload =>
  axios.post(`/backoffice/partnership/systems/commissions/reject/`, { ...payload });

export const getRewardFrequencies = () => axios.get(`/backoffice/partnership/systems/account/freq_of_payments/`);

export const addPartnerAccountTag = (accountId, tagId) =>
  axios.post(`/backoffice/partnership/systems/${accountId}/tags/${tagId}/`);
export const addPartnerAccountTags = (accountId, tags) =>
  axios.post(`/backoffice/partnership/systems/${accountId}/tags/`, { tags });

export const deletePartnerAccountTag = (accountId, tagId) =>
  axios.delete(`/backoffice/partnership/systems/${accountId}/tags/${tagId}/`);

export const boGetPartnershipRequests = search =>
  axios.get('/backoffice/partnership/requests/', { params: { ...search } });

export const boGetPartnershipRequest = requestId => axios.get(`/backoffice/partnership/requests/${requestId}`);

export const getPartnershipLinkDistributions = params =>
  axios.get('/backoffice/partnership/link-distributions/', { params });

export const getManagedLinkDistributions = params =>
  axios.get('/backoffice/partnership/link-distributions/manage/', { params });
export const createManagedLinkDistribution = data =>
  axios.post('/backoffice/partnership/link-distributions/manage/', data);
export const updateManagedLinkDistribution = ({ id, ...data }) =>
  axios.patch(`/backoffice/partnership/link-distributions/manage/${id}/`, data);
export const deleteManagedLinkDistribution = id =>
  axios.delete(`/backoffice/partnership/link-distributions/manage/${id}/`);
export const toggleManagedLinkDistributionSalesVisibility = id =>
  axios.post(`/backoffice/partnership/link-distributions/manage/${id}/toggle-sales-visibility/`);

export const confirmPartner = (userId, salesCodes) =>
  axios.post(`/backoffice/partnership/${userId}/verify/`, { salesCodes });

export const createPartnerAccountsExport = (ext, timePeriod) =>
  axios.post('/reports/partner_accounts_export/', { ext, startEndDate: timePeriod });
export const getPartnerAccountsExports = search =>
  axios.get('/reports/partner_accounts_export/', { params: { ...search } });
export const downloadPartnerAccountsExport = (id, name) =>
  axios.get(`/reports/partner_accounts_export/${id}/`, { params: { name }, responseType: 'blob' });

export const createPartnerCommissionExport = (ext, timePeriod) =>
  axios.post('/reports/commission_export/', { ext, startEndDate: timePeriod });
export const getPartnerCommissionExports = search =>
  axios.get('/reports/commission_export/', { params: { ...search } });
export const downloadPartnerCommissionExport = (id, name) =>
  axios.get(`/reports/commission_export/${id}/`, { params: { name }, responseType: 'blob' });
